export const awsConfig = {
  region: 'us-west-2',
  userPoolId: 'us-west-2_dES2SPreJ',
  userPoolClientId: '5mtjq568v16ah7klq8mrg9010q',
  userPoolDomain: 'meppy-auth-090600307342',
  identityPoolId: 'us-west-2:158d729c-44c3-4c3d-b675-bf9e2162f29e'
};
